import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Notes from './pages/Notes';
import Summarizer from './pages/Summarizer';
import Requests from './pages/Requests';
import Profile from './pages/Profile';
import Colleges from './pages/Colleges';
import CollegeDetails from './pages/CollegeDetails';
import Upload from './pages/Upload';
import UserManagement from './pages/UserManagement';
import { ThemeProvider } from './context/ThemeContext';
import './Main.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    if (token && user) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    window.location.href = '/login';
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading Notebook...</p>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Landing page for unauthenticated visitors, Dashboard for logged in users */}
            <Route
              path="/"
              element={
                isAuthenticated ?
                  <Dashboard onLogout={handleLogout} /> :
                  <LandingPage />
              }
            />

            <Route
              path="/landing"
              element={
                isAuthenticated ?
                  <Navigate to="/" /> :
                  <LandingPage />
              }
            />

            {/* Public Auth Route */}
            <Route
              path="/login"
              element={
                isAuthenticated ?
                  <Navigate to="/" /> :
                  <Login onLogin={handleLogin} />
              }
            />

            {/* Protected Workspace Routes */}
            <Route
              path="/dashboard"
              element={
                isAuthenticated ?
                  <Dashboard onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/notes"
              element={
                isAuthenticated ?
                  <Notes onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/summarizer"
              element={
                isAuthenticated ?
                  <Summarizer onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/requests"
              element={
                isAuthenticated ?
                  <Requests onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/profile"
              element={
                isAuthenticated ?
                  <Profile onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/colleges"
              element={
                isAuthenticated ?
                  <Colleges onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/colleges/:id"
              element={
                isAuthenticated ?
                  <CollegeDetails onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/upload"
              element={
                isAuthenticated ?
                  <Upload onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />
            <Route
              path="/admin/users"
              element={
                isAuthenticated ?
                  <UserManagement onLogout={handleLogout} /> :
                  <Navigate to="/login" />
              }
            />

            {/* Catch-all route */}
            <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/"} />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;